export default __webpack_public_path__ + "static/media/spacer.d9109c94.svg";